define('util/SchemaPreprocessor',[
    'lib/lodash4'
], function (_) {
    'use strict';

    // Include or exclude properties from a schema.
    var filterPropertiesRecursive = function (inputSchema, outputSchema, behavior, prefix, exclude) {
        _.each(inputSchema.properties, function (schemaPropertyValue, schemaPropertyName) {
            var currentPropertyKey = schemaPropertyName;
            if (prefix) {
                currentPropertyKey = prefix + '.' + schemaPropertyName;
            }

            if (schemaPropertyValue.type === 'object') {
                filterPropertiesRecursive(
                    inputSchema.properties[schemaPropertyName],
                    outputSchema.properties[schemaPropertyName],
                    behavior,
                    currentPropertyKey,
                    exclude
                );
            }
            else {
                var isBehaviorProperty = _.includes(behavior, currentPropertyKey);
                var removeProperty = (isBehaviorProperty && exclude) || (!isBehaviorProperty && !exclude);
                if (removeProperty) {
                    delete outputSchema.properties[schemaPropertyName];
                }
            }
        });
    };

    // Remove schema properties that have no children.
    var removeEmptyPropertiesRecursive = function (schema) {
        _.each(schema.properties, function (schemaPropertyValue, schemaPropertyName, schema) {
            if (schemaPropertyValue.type === 'object') {
                removeEmptyPropertiesRecursive(schema[schemaPropertyName]);
                if (Object.keys(schemaPropertyValue.properties).length === 0) {
                    delete schema[schemaPropertyName];
                }
            }
        });
    };

    var SchemaPreprocessor = function (schema) {
        var self = this;

        /**
         * Remove properties from the schema that are not part of the behavior.
         */
        self.inclusionBehavior = function (behavior) {
            var filteredSchema = _.cloneDeep(schema);
            filterPropertiesRecursive(schema, filteredSchema, behavior, '', false);
            removeEmptyPropertiesRecursive(filteredSchema);
            return filteredSchema;
        };

        /**
         * Remove properties from the schema that are part of the behavior.
         */
        self.exclusionBehavior = function(behavior) {
            var filteredSchema = _.cloneDeep(schema);
            filterPropertiesRecursive(schema, filteredSchema, behavior, '', true);
            removeEmptyPropertiesRecursive(filteredSchema);
            return filteredSchema;
        };
    };

    return SchemaPreprocessor;
});
